var _path, _path2, _path3, _linearGradient, _path4, _linearGradient2, _path5, _linearGradient3, _path6, _ellipse, _ellipse2, _path7, _path8, _path9, _path10, _g, _path11, _defs, _mask, _linearGradient4, _path12, _defs2, _mask2, _linearGradient5, _path13, _path14, _linearGradient6, _path15, _defs3, _mask3, _linearGradient7, _path16, _defs4, _mask4, _linearGradient8, _path17, _defs5, _mask5, _linearGradient9, _path18, _defs6, _mask6, _linearGradient10, _path19, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDino11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 365.12,
    viewBox: "0 0 250 365.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8EC23F",
    d: "M229 312.35c-.38.1-.76.2-1.14.29.38-.09.76-.19 1.14-.29zM226.02 313.09c-.41.1-.82.19-1.24.28.42-.09.83-.18 1.24-.28zM231.84 311.57c-.33.09-.67.19-1.01.28.34-.09.68-.19 1.01-.28zM222.91 313.78l-1.32.27c.45-.09.88-.18 1.32-.27zM216.29 314.99c-.47.08-.94.15-1.43.22.48-.07.95-.14 1.43-.22zM219.67 314.42c-.46.08-.92.17-1.38.25.46-.08.92-.17 1.38-.25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E41E26",
    d: "M13.66 82.24c-.13-.09-.25-.18-.37-.28.11.11.24.19.37.28zM14.32 82.66c-.14-.07-.27-.14-.4-.23.13.09.26.16.4.23zM15.04 82.99c-.16-.06-.31-.12-.46-.19.15.08.3.13.46.19zM12.68 81.42c.11.11.23.22.35.32-.12-.1-.23-.21-.35-.32zM16 83.27c-.25-.04-.49-.1-.73-.18.24.07.48.13.73.18zM11.57 80.1c.1.14.21.28.32.42-.11-.14-.22-.28-.32-.42zM10.11 77.6c.09.19.19.38.29.57-.1-.19-.2-.38-.29-.57zM11.06 79.33c.1.16.2.31.3.46-.1-.15-.2-.3-.3-.46zM10.57 78.5c.1.18.19.34.29.51-.1-.17-.19-.34-.29-.51zM8.5 73.5c.09.28.18.56.28.84-.1-.27-.19-.55-.28-.84zM8.14 72.34c.09.32.19.64.29.96-.1-.32-.19-.63-.29-.96zM8.87 74.61c.09.25.18.51.27.75l-.27-.75zM9.26 75.66c.09.23.18.46.28.68-.1-.22-.19-.45-.28-.68zM9.67 76.66c.09.21.18.42.28.62-.09-.21-.19-.41-.28-.62zM12.11 80.79c.11.13.22.25.33.37-.11-.11-.22-.24-.33-.37z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8EC23F",
    d: "M15.04 82.99c-.16-.06-.31-.12-.46-.19.15.08.3.13.46.19zM14.32 82.66c-.14-.07-.27-.14-.4-.23.13.09.26.16.4.23zM13.66 82.24c-.13-.09-.25-.18-.37-.28.11.11.24.19.37.28zM12.68 81.42c.11.11.23.22.35.32-.12-.1-.23-.21-.35-.32zM16 83.27c-.25-.04-.49-.1-.73-.18.24.07.48.13.73.18zM10.57 78.5c.1.18.19.34.29.51-.1-.17-.19-.34-.29-.51zM10.11 77.6c.09.19.19.38.29.57-.1-.19-.2-.38-.29-.57zM11.57 80.1c.1.14.21.28.32.42-.11-.14-.22-.28-.32-.42zM9.67 76.66c.09.21.18.42.28.62-.09-.21-.19-.41-.28-.62zM9.26 75.66c.09.23.18.46.28.68-.1-.22-.19-.45-.28-.68zM8.14 72.34c.09.32.19.64.29.96-.1-.32-.19-.63-.29-.96zM8.5 73.5c.09.28.18.56.28.84-.1-.27-.19-.55-.28-.84zM8.87 74.61c.09.25.18.51.27.75l-.27-.75zM11.06 79.33c.1.16.2.31.3.46-.1-.15-.2-.3-.3-.46zM12.11 80.79c.11.13.22.25.33.37-.11-.11-.22-.24-.33-.37z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 128.439,
    y1: 341.207,
    x2: 139.471,
    y2: 324.25
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1E7086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#075363"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M138.72 277.85s-5.36 0-13.33 9.5c0 0 2.15 23.14 3.68 31.41 0 0-2.76 22.22-3.22 28.96 0 0 17.78 1.07 37.24-1.23 0 0 1.53-14.1-4.14-22.53-5.67-8.42-13.79-38.3-20.23-46.11z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 39.481,
    y1: 314.491,
    x2: 62.205,
    y2: 300.789
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1E7086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#075363"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M45.91 256.16s-10.79 15.23-3.96 54.75c0 0-4.75 35.8-5.68 39.41 0 0 11.48 1.5 34.59-.3 0 0 .13-32.34-2.51-41.52 0 .01-12.14-36.69-22.44-52.34z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 155.159,
    y1: 38.871,
    x2: 108.268,
    y2: 278.795
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#1E7086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#33839D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348,
    stopColor: "#4192B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#4699BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613,
    stopColor: "#4293B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#3685A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991,
    stopColor: "#207187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E7086"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M35.78 8.23S24.4 5.14 21.53 16.19c-2.87 11.05-2.65 18.9-3.09 25.97 0 0-13.7 6.41-13.04 13.92.65 7.51 2.86 25.86 10.6 27.19 7.74 1.33 25.86 0 33.37-1.77 0 0-7.74 36.25-10.83 49.95-3.09 13.7-14.14 68.73 0 118.24 14.14 49.5 41.11 69.84 83.98 66.74 42.87-3.09 61.44-22.1 61.44-22.1s30.5 27.51 54.37 36.13c0 0 11.93 5.3 2.98-3.64-8.95-8.95-30.5-19.89-44.75-46.74s-19.56-34.14-61.33-52.05c-41.77-17.9-60.33-26.85-66.3-51.71-5.97-24.86-1.33-79.89 2.65-98.12 3.98-18.25 26.74-54.72-35.8-69.97z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    cx: 48.7,
    cy: 44.81,
    rx: 6.63,
    ry: 11.69
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#231815",
    cx: 46.33,
    cy: 44.81,
    rx: 4.25,
    ry: 7.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#85BFD2",
    d: "M49.37 81.5s-7.74 36.25-10.83 49.95c-3.09 13.7-14.14 68.73 0 118.24 14.14 49.5 41.11 69.84 83.98 66.74 39.39-2.84 58.24-19.1 61.05-21.73-3.93-5.38-14.77-7.74-48.35-5.67-43.1 2.65-72.6-31.16-84.09-69.83-11.49-38.68 3.7-116.47 4.53-120.94.83-4.48 1.99-22.21 1.49-24.2-.5-1.99.5-9.78-24.03-3.81-18.07 4.4-23.64 2.31-25.31.91C9.4 77.18 11.94 82.57 16 83.27c7.73 1.32 25.85 0 33.37-1.77z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#8EC23F",
    d: "M212.72 315.51c-.46.06-.92.13-1.4.18.47-.05.93-.12 1.4-.18zM208.88 315.97c-.41.04-.81.09-1.23.13.41-.04.81-.09 1.23-.13z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#E41E26",
    d: "M147.67 312.35c-.38.1-.76.2-1.14.29.38-.09.76-.19 1.14-.29zM153.23 310.75c-.27.08-.54.17-.82.25.28-.08.56-.17.82-.25zM155.83 309.9c-.15.05-.31.1-.47.16.16-.06.32-.11.47-.16zM150.51 311.57c-.33.09-.67.19-1.01.28.34-.09.68-.19 1.01-.28zM171.34 303.13c-.14.08-.29.16-.43.23.14-.07.29-.15.43-.23zM167.69 305.02l-.48.24.48-.24zM163.41 306.98c-.12.05-.24.1-.36.16.13-.05.24-.11.36-.16zM144.69 313.09c-.41.1-.82.19-1.24.28.42-.09.83-.18 1.24-.28zM165.65 305.99c-.15.07-.3.14-.46.21.16-.07.31-.14.46-.21zM169.58 304.07c-.16.08-.31.16-.47.24.16-.08.32-.16.47-.24zM131.39 315.51c-.46.06-.92.13-1.4.18.47-.05.93-.12 1.4-.18zM127.55 315.97c-.41.04-.81.09-1.23.13.41-.04.81-.09 1.23-.13zM138.34 314.42c-.46.08-.92.17-1.38.25.46-.08.92-.17 1.38-.25zM134.96 314.99c-.47.08-.94.15-1.42.22.47-.07.94-.14 1.42-.22zM141.58 313.78c-.44.09-.87.18-1.32.27.45-.09.89-.18 1.32-.27zM182.69 295.48c-.06.05-.12.11-.19.16.07-.05.13-.11.19-.16zM172.97 302.22c-.12.07-.25.14-.38.21.13-.07.26-.14.38-.21zM175.87 300.47c-.06.03-.12.07-.17.11.05-.04.11-.08.17-.11zM180.42 297.31c-.01.01-.03.02-.04.03.01-.01.03-.02.04-.03zM174.47 301.33c-.09.05-.19.11-.28.17.09-.06.19-.11.28-.17zM181.35 296.59l-.15.12c.05-.04.09-.08.15-.12zM182.08 295.99l-.18.15c.07-.05.12-.1.18-.15zM183.53 294.72c-.05.05-.11.1-.17.15.07-.05.12-.1.17-.15zM183.17 295.06c-.06.05-.12.1-.18.16.06-.06.12-.11.18-.16z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#8EC23F",
    d: "M144.69 313.09c-.41.1-.82.19-1.24.28.42-.09.83-.18 1.24-.28zM153.23 310.75c-.27.08-.54.17-.82.25.28-.08.56-.17.82-.25zM150.51 311.57c-.33.09-.67.19-1.01.28.34-.09.68-.19 1.01-.28zM147.67 312.35c-.38.1-.76.2-1.14.29.38-.09.76-.19 1.14-.29zM155.83 309.9c-.15.05-.31.1-.47.16.16-.06.32-.11.47-.16zM167.69 305.02l-.48.24.48-.24zM165.65 305.99c-.15.07-.3.14-.46.21.16-.07.31-.14.46-.21zM169.58 304.07c-.16.08-.31.16-.47.24.16-.08.32-.16.47-.24zM163.41 306.98c-.12.05-.24.1-.36.16.13-.05.24-.11.36-.16zM138.34 314.42c-.46.08-.92.17-1.38.25.46-.08.92-.17 1.38-.25zM171.34 303.13c-.14.08-.29.16-.43.23.14-.07.29-.15.43-.23zM127.55 315.97c-.41.04-.81.09-1.23.13.41-.04.81-.09 1.23-.13zM134.96 314.99c-.47.08-.94.15-1.42.22.47-.07.94-.14 1.42-.22zM141.58 313.78c-.44.09-.87.18-1.32.27.45-.09.89-.18 1.32-.27zM131.39 315.51c-.46.06-.92.13-1.4.18.47-.05.93-.12 1.4-.18zM182.08 295.99l-.18.15c.07-.05.12-.1.18-.15zM172.97 302.22c-.12.07-.25.14-.38.21.13-.07.26-.14.38-.21zM181.35 296.59l-.15.12c.05-.04.09-.08.15-.12zM180.42 297.31c-.01.01-.03.02-.04.03.01-.01.03-.02.04-.03zM175.87 300.47c-.06.03-.12.07-.17.11.05-.04.11-.08.17-.11zM174.47 301.33c-.09.05-.19.11-.28.17.09-.06.19-.11.28-.17zM183.53 294.72c-.05.05-.11.1-.17.15.07-.05.12-.1.17-.15zM182.69 295.48c-.06.05-.12.11-.19.16.07-.05.13-.11.19-.16zM183.17 295.06c-.06.05-.12.1-.18.16.06-.06.12-.11.18-.16z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "d",
    filterUnits: "userSpaceOnUse",
    x: 7.81,
    y: 71.14,
    width: 0.3,
    height: 1.1
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "back",
    floodColor: "#fff",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 7.81,
    y: 71.14,
    width: 0.3,
    height: 1.1,
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "e",
    filterUnits: "userSpaceOnUse",
    x: 7.81,
    y: 71.14,
    width: 0.3,
    height: 1.1
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "back",
    floodColor: "#fff",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: -9.454,
    y1: 57.629,
    x2: 14.659,
    y2: 77.095
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    mask: "url(#f)",
    fill: "url(#g)",
    d: "M8.11 72.23c-.1-.35-.19-.72-.29-1.08 0 0-.01-.01-.02-.01.11.37.21.73.31 1.09z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: -9.454,
    y1: 57.629,
    x2: 14.659,
    y2: 77.095
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7AB3C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#7AB3C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AB3C4"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M8.11 72.23c-.1-.35-.19-.72-.29-1.08 0 0-.01-.01-.02-.01.11.37.21.73.31 1.09z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "i",
    filterUnits: "userSpaceOnUse",
    x: 5.36,
    y: 7.83,
    width: 66.4,
    height: 65.04
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "back",
    floodColor: "#fff",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 5.36,
    y: 7.83,
    width: 66.4,
    height: 65.04,
    id: "SVGID_7_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#i)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "j",
    filterUnits: "userSpaceOnUse",
    x: 5.36,
    y: 7.83,
    width: 66.4,
    height: 65.04
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "back",
    floodColor: "#fff",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 14.478,
    y1: 28.02,
    x2: 38.568,
    y2: 47.468
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    mask: "url(#k)",
    fill: "url(#l)",
    d: "M36.33 18.51c7.32-2.7 24.9 1.83 35.43 8.02-6.23-7.29-17.3-13.74-35.98-18.29 0 0-11.38-3.09-14.25 7.96-2.87 11.05-2.65 18.9-3.09 25.97 0 0-13.7 6.41-13.04 13.92.32 3.57.99 9.59 2.44 15.07 1.5 1.24 6.03 2.97 19.45.36.08-.9.04-2.1-.23-3.71-1.11-6.63-4.64-12.6 2.43-18.12 7.06-5.54-1.56-28.09 6.84-31.18z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 14.478,
    y1: 28.02,
    x2: 38.568,
    y2: 47.468
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7AB3C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#7AB3C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AB3C4"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M36.33 18.51c7.32-2.7 24.9 1.83 35.43 8.02-6.23-7.29-17.3-13.74-35.98-18.29 0 0-11.38-3.09-14.25 7.96-2.87 11.05-2.65 18.9-3.09 25.97 0 0-13.7 6.41-13.04 13.92.32 3.57.99 9.59 2.44 15.07 1.5 1.24 6.03 2.97 19.45.36.08-.9.04-2.1-.23-3.71-1.11-6.63-4.64-12.6 2.43-18.12 7.06-5.54-1.56-28.09 6.84-31.18z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E7086",
    d: "M28.49 35.85c-.18 5.01-1.33 6.53-2.59 6.48-1.27-.05-2.16-1.64-1.98-6.65.18-5.01 1.35-9.04 2.61-8.99 1.26.05 2.14 4.15 1.96 9.16z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "n",
    filterUnits: "userSpaceOnUse",
    x: 59.13,
    y: 79.56,
    width: 185.5,
    height: 252.28
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "back",
    floodColor: "#fff",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 59.13,
    y: 79.56,
    width: 185.5,
    height: 252.28,
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#n)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "o",
    filterUnits: "userSpaceOnUse",
    x: 59.13,
    y: 79.56,
    width: 185.5,
    height: 252.28
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "back",
    floodColor: "#fff",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientUnits: "userSpaceOnUse",
    x1: 193.095,
    y1: 343.119,
    x2: 63.588,
    y2: 65.098
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.236,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    mask: "url(#p)",
    fill: "url(#q)",
    d: "M196.55 280.06c-14.25-26.85-19.56-34.14-61.33-52.05-41.77-17.9-60.33-26.85-66.3-51.71-5.83-24.27-1.54-77.29 2.37-96.75-2.19 1.25-6.18 4.32-7.01 10.39 0 0-16.24 88.01 8.95 114.53 25.19 26.52 52.71 29.17 64.97 34.48 12.27 5.31 35.47 16.91 45.08 30.5s28.84 41.77 53.04 55.36c0 0 5.25 4.3 8.05 7.02.65-.45.13-1.82-3.08-5.03-8.93-8.94-30.48-19.88-44.74-46.74z"
  })))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientUnits: "userSpaceOnUse",
    x1: 193.095,
    y1: 343.119,
    x2: 63.588,
    y2: 65.098
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7AB3C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#7AB3C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AB3C4"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fill: "url(#r)",
    d: "M196.55 280.06c-14.25-26.85-19.56-34.14-61.33-52.05-41.77-17.9-60.33-26.85-66.3-51.71-5.83-24.27-1.54-77.29 2.37-96.75-2.19 1.25-6.18 4.32-7.01 10.39 0 0-16.24 88.01 8.95 114.53 25.19 26.52 52.71 29.17 64.97 34.48 12.27 5.31 35.47 16.91 45.08 30.5s28.84 41.77 53.04 55.36c0 0 5.25 4.3 8.05 7.02.65-.45.13-1.82-3.08-5.03-8.93-8.94-30.48-19.88-44.74-46.74z"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "s",
    filterUnits: "userSpaceOnUse",
    x: 44.27,
    y: 58.73,
    width: 190.27,
    height: 270.21
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "back",
    floodColor: "#fff",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 44.27,
    y: 58.73,
    width: 190.27,
    height: 270.21,
    id: "SVGID_13_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#s)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "t",
    filterUnits: "userSpaceOnUse",
    x: 44.27,
    y: 58.73,
    width: 190.27,
    height: 270.21
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "back",
    floodColor: "#fff",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    gradientUnits: "userSpaceOnUse",
    x1: 44.266,
    y1: 193.841,
    x2: 234.532,
    y2: 193.841
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.967,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    mask: "url(#u)",
    fill: "url(#v)",
    d: "M231.41 327.55c-12.09-7.71-29.93-22.79-42.61-34.34-14.81-13.48-21.88-15.25-35.36-15.03-13.48.22-47.52 3.54-76.03-25.42C48.9 223.81 51.55 168.12 52 153.09c.44-15.03 5.3-50.83 7.73-63.87 2.43-13.04.88-21.44.88-21.44 2.87-2.87 1.33-9.06 1.33-9.06.66 7.51-17.46 9.06-17.46 9.06l-.23.41c13.06-1.26 12.47 4.21 12.88 5.83.5 1.99-.66 19.72-1.49 24.2s-16.02 82.27-4.53 120.94c11.49 38.68 41 72.49 84.09 69.83 33.58-2.07 44.41.29 48.35 5.67.25-.23.38-.37.38-.37s27.4 24.71 50.59 34.63c-1.02-.41-2.06-.87-3.11-1.37z"
  })))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    gradientUnits: "userSpaceOnUse",
    x1: 44.266,
    y1: 193.841,
    x2: 234.532,
    y2: 193.841
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4699BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951,
    stopColor: "#4699BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4699BA"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M231.41 327.55c-12.09-7.71-29.93-22.79-42.61-34.34-14.81-13.48-21.88-15.25-35.36-15.03-13.48.22-47.52 3.54-76.03-25.42C48.9 223.81 51.55 168.12 52 153.09c.44-15.03 5.3-50.83 7.73-63.87 2.43-13.04.88-21.44.88-21.44 2.87-2.87 1.33-9.06 1.33-9.06.66 7.51-17.46 9.06-17.46 9.06l-.23.41c13.06-1.26 12.47 4.21 12.88 5.83.5 1.99-.66 19.72-1.49 24.2s-16.02 82.27-4.53 120.94c11.49 38.68 41 72.49 84.09 69.83 33.58-2.07 44.41.29 48.35 5.67.25-.23.38-.37.38-.37s27.4 24.71 50.59 34.63c-1.02-.41-2.06-.87-3.11-1.37z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#8EC23F",
    d: "M238.31 330.45c-1.01-.36-2.04-.77-3.07-1.2 1.03.43 2.06.84 3.07 1.2z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    gradientUnits: "userSpaceOnUse",
    x1: 157.233,
    y1: 333.434,
    x2: 177.455,
    y2: 306.913
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4699BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E7086"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M161.25 278.08s-5.8 0-14.42 10.28c0 0 2.32 25.03 3.98 33.98 0 0-2.98 24.03-3.48 31.33 0 0 19.23 1.16 40.28-1.33 0 0 1.66-15.25-4.47-24.37-6.14-9.12-14.93-41.44-21.89-49.89z"
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "y",
    filterUnits: "userSpaceOnUse",
    x: 146.83,
    y: 278.08,
    width: 18.64,
    height: 75.85
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "back",
    floodColor: "#fff",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back"
  })))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 146.83,
    y: 278.08,
    width: 18.64,
    height: 75.85,
    id: "SVGID_17_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#y)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "z",
    filterUnits: "userSpaceOnUse",
    x: 146.83,
    y: 278.08,
    width: 18.64,
    height: 75.85
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "back",
    floodColor: "#fff",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    gradientUnits: "userSpaceOnUse",
    x1: 143.69,
    y1: 327.207,
    x2: 174.851,
    y2: 302.012
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    mask: "url(#A)",
    fill: "url(#B)",
    d: "M162.52 286.14c1.24-.83 2.24-.93 2.95-.8-1.45-3.09-2.87-5.63-4.22-7.27 0 0-5.8 0-14.42 10.28 0 0 2.32 25.03 3.98 33.98 0 0-2.98 24.03-3.48 31.33 0 0 3.73.22 9.7.26.07-7.83.24-25.26.41-28.66.22-4.42-.88-8.84-.88-8.84s-1.77-9.95-2.87-18.79c-1.11-8.84 6.18-9.72 8.83-11.49z"
  })))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    gradientUnits: "userSpaceOnUse",
    x1: 143.69,
    y1: 327.207,
    x2: 174.851,
    y2: 302.012
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7AB3C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#7AB3C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AB3C4"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M162.52 286.14c1.24-.83 2.24-.93 2.95-.8-1.45-3.09-2.87-5.63-4.22-7.27 0 0-5.8 0-14.42 10.28 0 0 2.32 25.03 3.98 33.98 0 0-2.98 24.03-3.48 31.33 0 0 3.73.22 9.7.26.07-7.83.24-25.26.41-28.66.22-4.42-.88-8.84-.88-8.84s-1.77-9.95-2.87-18.79c-1.11-8.84 6.18-9.72 8.83-11.49z"
  })), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "D",
    filterUnits: "userSpaceOnUse",
    x: 163.07,
    y: 289.96,
    width: 24.73,
    height: 63.38
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "back",
    floodColor: "#fff",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back"
  })))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 163.07,
    y: 289.96,
    width: 24.73,
    height: 63.38,
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#D)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "E",
    filterUnits: "userSpaceOnUse",
    x: 163.07,
    y: 289.96,
    width: 24.73,
    height: 63.38
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "back",
    floodColor: "#fff",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    gradientUnits: "userSpaceOnUse",
    x1: 178.008,
    y1: 334.55,
    x2: 172.373,
    y2: 297.422
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.085,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    mask: "url(#F)",
    fill: "url(#G)",
    d: "M187.6 352.33s1.66-15.25-4.47-24.37c-4.39-6.53-10.15-24.96-15.61-38-2.41.93-4.44 1.87-4.44 1.87s7.13 23.87 8.78 28.84c1.66 4.97 2.49 7.79 3.81 10.11 1.19 2.07 1.97 16.05.94 22.55 3.54-.23 7.24-.56 10.99-1z"
  })))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    gradientUnits: "userSpaceOnUse",
    x1: 178.008,
    y1: 334.55,
    x2: 172.373,
    y2: 297.422
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1E5B6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E5B6A"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fill: "url(#H)",
    d: "M187.6 352.33s1.66-15.25-4.47-24.37c-4.39-6.53-10.15-24.96-15.61-38-2.41.93-4.44 1.87-4.44 1.87s7.13 23.87 8.78 28.84c1.66 4.97 2.49 7.79 3.81 10.11 1.19 2.07 1.97 16.05.94 22.55 3.54-.23 7.24-.56 10.99-1z"
  })), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "I",
    filterUnits: "userSpaceOnUse",
    x: 7.81,
    y: 71.14,
    width: 41.79,
    height: 12.66
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "back",
    floodColor: "#fff",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back"
  })))), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 7.81,
    y: 71.14,
    width: 41.79,
    height: 12.66,
    id: "SVGID_23_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#I)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "J",
    filterUnits: "userSpaceOnUse",
    x: 7.81,
    y: 71.14,
    width: 41.79,
    height: 12.66
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "back",
    floodColor: "#fff",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    gradientUnits: "userSpaceOnUse",
    x1: 7.81,
    y1: 77.471,
    x2: 49.603,
    y2: 77.471
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    mask: "url(#K)",
    fill: "url(#L)",
    d: "M16 83.27c7.74 1.33 25.86 0 33.37-1.77 1.99-5.75-9.06-2.87-16.58-3.31-5.03-.29-6.19-4.05-6.41-6.5-12.76 2.38-17.12.67-18.57-.54C9.4 77.18 11.94 82.57 16 83.27z"
  })))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    gradientUnits: "userSpaceOnUse",
    x1: 7.81,
    y1: 77.471,
    x2: 49.603,
    y2: 77.471
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    fill: "url(#M)",
    d: "M16 83.27c7.74 1.33 25.86 0 33.37-1.77 1.99-5.75-9.06-2.87-16.58-3.31-5.03-.29-6.19-4.05-6.41-6.5-12.76 2.38-17.12.67-18.57-.54C9.4 77.18 11.94 82.57 16 83.27z"
  })), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "N",
    filterUnits: "userSpaceOnUse",
    x: 31.5,
    y: 133.35,
    width: 53,
    height: 176.11
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "back",
    floodColor: "#fff",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back"
  })))), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 31.5,
    y: 133.35,
    width: 53,
    height: 176.11,
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#N)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "O",
    filterUnits: "userSpaceOnUse",
    x: 31.5,
    y: 133.35,
    width: 53,
    height: 176.11
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "back",
    floodColor: "#fff",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    gradientUnits: "userSpaceOnUse",
    x1: 31.505,
    y1: 221.412,
    x2: 84.507,
    y2: 221.412
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("path", {
    mask: "url(#P)",
    fill: "url(#Q)",
    d: "M41.74 135.53l-3.63-2.17c-3.54 16.31-13.14 68.84.42 116.32 8.77 30.69 22.47 50.15 41.82 59.79 1.57-6.97 4.15-19.13 4.15-19.13-61.87-34.92-42.76-154.81-42.76-154.81z"
  })))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    gradientUnits: "userSpaceOnUse",
    x1: 31.505,
    y1: 221.412,
    x2: 84.507,
    y2: 221.412
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    fill: "url(#R)",
    d: "M41.74 135.53l-3.63-2.17c-3.54 16.31-13.14 68.84.42 116.32 8.77 30.69 22.47 50.15 41.82 59.79 1.57-6.97 4.15-19.13 4.15-19.13-61.87-34.92-42.76-154.81-42.76-154.81z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    gradientUnits: "userSpaceOnUse",
    x1: 76.338,
    y1: 324.291,
    x2: 109.93,
    y2: 303.959
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4699BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E7086"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#S)",
    d: "M78.09 267.64c-1.78 4.78-3.14 10.62-3.19 17.4 0 0 .99 10.11 6.96 28.18 0 0-5.97 39.45-7.13 43.43 0 0 14.42 1.66 43.43-.33 0 0 .17-35.64-3.15-45.75 0 0-10.5-27.85-21.46-47.18-2.26-3.97-13.46-1.12-15.46 4.25z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "T",
    filterUnits: "userSpaceOnUse",
    x: 74.73,
    y: 261.53,
    width: 22.44,
    height: 95.62
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "back",
    floodColor: "#fff",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 74.73,
    y: 261.53,
    width: 22.44,
    height: 95.62,
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#T)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "U",
    filterUnits: "userSpaceOnUse",
    x: 74.73,
    y: 261.53,
    width: 22.44,
    height: 95.62
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "back",
    floodColor: "#fff",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    gradientUnits: "userSpaceOnUse",
    x1: 70.438,
    y1: 316.892,
    x2: 108.229,
    y2: 296.339
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    mask: "url(#V)",
    fill: "url(#W)",
    d: "M82.97 357.15c2.36-10.27 5.37-34.14 5.96-37.63.88-5.3-1.33-10.61-5.08-23.87-3.76-13.26-1.1-13.92.88-19.89 1.43-4.28 8.53-5.37 12.44-5.65-.59-1.15-1.19-2.28-1.79-3.4-.01-.02-.02-.04-.04-.07-.6-1.11-1.2-2.2-1.8-3.26-2.25-3.96-13.46-1.11-15.46 4.26-1.78 4.78-3.14 10.62-3.19 17.4 0 0 .99 10.11 6.96 28.18 0 0-5.97 39.45-7.13 43.43.01-.01 2.75.31 8.25.5z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    gradientUnits: "userSpaceOnUse",
    x1: 70.438,
    y1: 316.892,
    x2: 108.229,
    y2: 296.339
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7AB3C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#7AB3C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AB3C4"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#X)",
    d: "M82.97 357.15c2.36-10.27 5.37-34.14 5.96-37.63.88-5.3-1.33-10.61-5.08-23.87-3.76-13.26-1.1-13.92.88-19.89 1.43-4.28 8.53-5.37 12.44-5.65-.59-1.15-1.19-2.28-1.79-3.4-.01-.02-.02-.04-.04-.07-.6-1.11-1.2-2.2-1.8-3.26-2.25-3.96-13.46-1.11-15.46 4.26-1.78 4.78-3.14 10.62-3.19 17.4 0 0 .99 10.11 6.96 28.18 0 0-5.97 39.45-7.13 43.43.01-.01 2.75.31 8.25.5z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Y",
    filterUnits: "userSpaceOnUse",
    x: 98.16,
    y: 276.58,
    width: 20,
    height: 80.42
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "back",
    floodColor: "#fff",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 98.16,
    y: 276.58,
    width: 20,
    height: 80.42,
    id: "SVGID_33_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Y)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Z",
    filterUnits: "userSpaceOnUse",
    x: 98.16,
    y: 276.58,
    width: 20,
    height: 80.42
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "back",
    floodColor: "#fff",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    gradientUnits: "userSpaceOnUse",
    x1: 110.439,
    y1: 353.554,
    x2: 106.241,
    y2: 277.53
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.085,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    mask: "url(#aa)",
    fill: "url(#ab)",
    d: "M105.7 356.99c3.8-.15 7.95-.37 12.46-.68 0 0 .17-35.64-3.15-45.75 0 0-6.5-17.23-14.6-33.99-1.07 1.42-2.94 4.44-1.97 7.35l9.06 27.63s2.21 4.86 1.77 10.61c-.44 5.75-.88 23.87-.88 23.87l-2.69 10.96z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    gradientUnits: "userSpaceOnUse",
    x1: 110.439,
    y1: 353.554,
    x2: 106.241,
    y2: 277.53
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1E5B6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E5B6A"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fill: "url(#ac)",
    d: "M105.7 356.99c3.8-.15 7.95-.37 12.46-.68 0 0 .17-35.64-3.15-45.75 0 0-6.5-17.23-14.6-33.99-1.07 1.42-2.94 4.44-1.97 7.35l9.06 27.63s2.21 4.86 1.77 10.61c-.44 5.75-.88 23.87-.88 23.87l-2.69 10.96z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    fill: "#4699BA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.71 259.83s5.05-2.51 3.02-5.22c-2.03-2.7-1.87-6.87-5.35-7.44-3.48-.57-6.21 1.53-8.44 4.83-2.23 3.31-1.93 8.78 1.56 10.72 3.49 1.95 5.11-.24 9.21-2.89zM72.66 219.5s4.29-2.13 2.57-4.43c-1.72-2.3-1.59-5.84-4.55-6.33-2.96-.49-5.28 1.3-7.18 4.11-1.89 2.81-1.64 7.47 1.32 9.12 2.98 1.65 4.36-.21 7.84-2.47zM123.2 242.03c3.51.22 4.86 1.02 4.46-2.13-.41-3.15.31-6.96-2.84-9.01s-6.68-7-9.05-4.38c-2.37 2.62-6.2 2.53-5.78 7.05.4 4.52-1.57 7.56 13.21 8.47zM172.53 274.38c2.8.17 3.88.82 3.56-1.7-.32-2.52.25-5.56-2.27-7.2-2.52-1.64-5.34-5.59-7.23-3.5-1.9 2.09-4.95 2.02-4.62 5.63.34 3.62-1.25 6.04 10.56 6.77zM109.9 253.06s3.14-.32 2.72-3.1c-.42-2.79 1.48-4.61-2.52-7.02-4-2.41-9.82-3.21-11.45-5.49-1.62-2.29-4.88-2.03-6.53.9-1.64 2.92-4.28 3.08-2.79 8.79 1.49 5.72 5.61 9.92 8.24 10.14 2.63.21 5.62-3.9 12.33-4.22zM88.02 235.14s5.12-.61 4.55-4.08c-.56-3.47-1.67-4.92-1.48-6.09.2-1.16-1.51-3.24-5.38-3.23-3.87.01-5.51 1.57-8.37.88-2.86-.69-2.58 1.05-2.1 4.73.48 3.68.19 6.79 3.63 7.1 3.44.31 7.41 1.09 9.15.69zM139.06 267.58s4.26-.97 3.08-4.32c-1.19-3.35-2.26-6.28-2.39-7.33s-1.29-3.77-4.62-2.66c-3.32 1.11-7.65 2.92-9.61 2.48-1.96-.44-3.01.37-3.03 4.21-.02 3.85 1.77 8.82 4.37 8.78 2.58-.04 8.13.02 12.2-1.16zM117.95 265.35s3.31-3.85-.83-5.94c-4.14-2.09-5.93-4.33-8.03-2.71-2.1 1.62-5.77 3.57-3.16 5.9 2.62 2.33 9.42 7.65 12.02 2.75zM104.66 235.7s2.82-2.31 1.68-4.4c-1.14-2.09-1.69-4.56-4.15-3.09-2.47 1.46-4.91 2.19-3.53 4.38 1.37 2.19 4.83 5.24 6 3.11zM63.88 206.86s2.82-2.31 1.68-4.4c-1.14-2.09-1.69-4.56-4.15-3.09-2.47 1.46-4.91 2.19-3.53 4.38 1.38 2.19 4.83 5.24 6 3.11zM126.04 251.04s-5.76.1-6.12-1.79c-.36-1.89 0-4.48 3.16-4.16 3.16.31 7.67-.55 7.31 2.04-.37 2.58.08 4.26-4.35 3.91zM151.49 266.5s5.47 1.8 5.19 3.71c-.28 1.9-1.47 4.23-4.35 2.89-2.88-1.34-7.42-2-6.23-4.33 1.18-2.32 1.31-4.05 5.39-2.27zM83.88 246.49s4.02-2.44 2.22-4.31c-1.8-1.87-2.15-5.5-4.61-4.4-2.45 1.09-4.28 3.08-2.57 5.15 1.71 2.08 3.94 4.63 4.96 3.56zM143.8 249.58s1.62-2.19.04-2.85c-1.59-.66-5.69-5.59-7.28-4.51-1.59 1.08-2.65 3.63.55 5.58 3.19 1.95 5.95 3.22 6.69 1.78z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDino11);
export default __webpack_public_path__ + "static/media/dino11.8f765a88c60265794d96184bcabe2f04.svg";
export { ForwardRef as ReactComponent };